import {createMuiTheme} from "@material-ui/core/styles";
import lightGreen from "@material-ui/core/colors/lightGreen";


export const materialTheme = createMuiTheme({
    palette: {
        secondary: {
            main: "rgba(0, 0, 0, 0.87)",
        },
    },
    overrides: {
        MuiPickersDateRangePickerInput: {
            root: {
                display: "block"

            }
        },
        MuiPickersPopper: {
            root: {}
        },
        MuiPickersToolbar: {
            root: {
                background: "linear-gradient(50deg, #f46b45, #eea849)",
                display: "block"
            },
        },
        MuiPickersCalendarHeader: {
            root: {
                // backgroundColor: lightBlue.A200,
                // color: "white",
            },
        },
        MuiPickersDay: {
            root: {
                color: "black",
                "&:focus": {
                    background: "linear-gradient(50deg, #f46b45, #eea849)",
                    "&$selected": {
                        background: "linear-gradient(50deg, #f46b45, #eea849)",
                        "&:hover": {
                            background: "linear-gradient(50deg, #f46b45, #eea849)",
                        },
                    },
                },
                "&$selected": {
                    background: "linear-gradient(50deg, #f46b45, #eea849)",
                    "&:hover": {
                        background: "linear-gradient(50deg, #f46b45, #eea849)",
                    },

                },
            },
            today: {
                color: lightGreen["900"],
            },
        },
        MuiPickersModalDialog: {
            dialogAction: {
                color: lightGreen["400"],
            },
        },

        MuiFormHelperText: {
            root: {
                "&.Mui-error": {
                    margin: "2px 4px 0"
                },
            }
        }

    },
});
